import { getLang, getLocaleCountry, getRegion, getStoreByLocale } from './project'

// Environments
export const DEV = process.env.NEXT_PUBLIC_VERCEL_ENV === 'development'
export const STAGING = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
export const PRO = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'

export const STORE_ABBR = process.env.NEXT_PUBLIC_STORE_ABBR
export const IS_MMF_STORE = STORE_ABBR === 'mmf'
export const IS_HM_STORE = STORE_ABBR === 'hm'

export const HOSTNAME = process.env.NEXT_PUBLIC_PROJECT_HOSTNAME
export const CLIENT_NAME = process.env.NEXT_PUBLIC_CLIENT_NAME

export const DY_SIGNUP_ALLOWED = process.env.NEXT_PUBLIC_DY_SIGNUP_ALLOWED === 'true'
export const DY_LOGIN_ALLOWED = process.env.NEXT_PUBLIC_DY_LOGIN_ALLOWED === 'true'
export const DY_SHOPPING_ALLOWED = process.env.NEXT_PUBLIC_DY_SHOPPING_ALLOWED === 'true'
export const DY_GUEST_CART_ALLOWED = DY_SHOPPING_ALLOWED && process.env.NEXT_PUBLIC_DY_GUEST_CART_ALLOWED === 'true'
export const DY_DELIVERY_DATES_DISABLED = process.env.NEXT_PUBLIC_DY_DELIVERY_DATES_DISABLED === 'true'

export const NEXT_PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL


// LOCALE STUFF
export const LANG_REGION = process.env.NEXT_PUBLIC_LOCALE
export const LANG = getLang(LANG_REGION)
export const REGION = getRegion(LANG_REGION)
export const LANG_COUNTRY = getLocaleCountry(LANG_REGION)
export const COUNTRY_CODE = LANG_COUNTRY?.split('-')?.[1]
export const COUNTRY_REGION = `${COUNTRY_CODE}-${REGION}`
export const STORE_NAME = getStoreByLocale[LANG_REGION]

const STORE_REGION = STORE_ABBR.toUpperCase() + '_' + REGION

// COOKIES
export const DY_COOKIE_SESSION = `DY_USER_${STORE_REGION}`
export const DY_COOKIE_CATALOG = `DY_USER_${STORE_REGION}_CATALOG`
export const DY_COOKIE_PAYMENT_METHOD = `DY_USER_${STORE_REGION}_PAYMENT_METHOD`
export const DY_COOKIE_GUEST_CART = `DY_GUEST_CART_${STORE_REGION}`
export const DY_COOKIE_DOMAIN = DEV ? 'localhost' : HOSTNAME

export * from './base'
export * from './project'

export const privatePaths = [
  '/welcome',
  '/shop',
  '/account',
  '/checkout',
  '/cart',
  '/shop/search'
]

export const getPathnameType = (pathname: string): 'private' | 'public' => {
  for (const path of privatePaths) {
    if (pathname.startsWith(path)) return 'private'
  }

  return 'public'
}
